<div class="site-container product-list" style="margin-top: 1.5rem; margin-bottom: 1.5rem">
  <div class="card">
    <!-- Mobile Filters Component -->
    @if (isMobile()) {
      <app-mobile-filters
        [sortingOptions]="sortingOptions"
        [(visible)]="mobileFiltersVisible"
        [(selectedCategoryIds)]="selectedCategoryIds"
        [(selectedSort)]="selectedSort"
        [(search)]="search"
        (applyFilters)="applyFilters()"
      />
    }

    <div class="grid">
      @if (!isMobile()) {
        <div class="col-12 md:col-3 desktop-filters">
          <p-accordion [multiple]="true">
            <p-accordion-panel [value]="'1'">
              <p-accordion-header>
                <div class="flex align-items-center gap-2">
                  <img
                    ngSrc="../../../assets/img/icons/filters/filters.svg"
                    alt="filters"
                    width="20"
                    height="20"
                  />
                  <span>Filters</span>
                </div>
              </p-accordion-header>
              <p-accordion-content>
                <app-category-filter
                  [(selectedCategoryIds)]="selectedCategoryIds"
                  (filtersChanged)="applyFilters()"
                />
              </p-accordion-content>
            </p-accordion-panel>
          </p-accordion>
        </div>
      }

      <!-- Right content (Search, Sort, Product List) -->
      <div class="col-12 md:col-9">
        @if (products.length > 0 || search) {
          <div class="grid mb-4">
            <div class="col-12 sm:col-8 desktop-search">
              <span class="p-input-icon-right block">
                <input
                  type="text"
                  class="search-input"
                  pInputText
                  placeholder="Search products"
                  [style]="{ width: '100%' }"
                  [(ngModel)]="search"
                  (ngModelChange)="applyFilters()"
                />
                <i class="pi pi-search input-icon-right"></i>
              </span>
            </div>
            <div class="col-12 sm:col-4 desktop-sort">
              <p-select
                [options]="sortingOptions"
                [(ngModel)]="selectedSort"
                placeholder="Sort By"
                [style]="{ width: '100%' }"
                [showClear]="true"
                (onChange)="applyFilters()"
              ></p-select>
            </div>
          </div>
        }

        <!-- Products + loading skeletons -->
        <div class="grid">
          @if (isLoading) {
            @for (skeleton of skeletons; track skeleton) {
              <div class="col-6 md:col-4">
                <div class="product">
                  <div class="mb-3 product-container">
                    <!-- Price Skeleton -->
                    <div class="product-price-container">
                      <p-skeleton width="50px" height="16px" borderRadius="12px"></p-skeleton>
                    </div>

                    <!-- Image Skeleton -->
                    <div class="image-skeleton">
                      <p-skeleton width="100%" height="208px"></p-skeleton>
                    </div>

                    <!-- Name Skeleton -->
                    <div class="flex flex-column align-items-center mt-3">
                      <p-skeleton width="115px" height="16px"></p-skeleton>
                      <p-skeleton width="135px" height="16px"></p-skeleton>
                    </div>
                  </div>
                </div>
              </div>
            }
          } @else {
            @for (product of products; track product.id) {
              <div class="col-6 md:col-6 xl:col-4">
                <div class="product-item">
                  <app-product-item [product]="product"></app-product-item>
                </div>
              </div>
            } @empty {
              <div class="no-products">
                <p class="text-center text-lg text-500">
                  No products available at the moment. Please check back later!
                </p>
              </div>
            }
          }
        </div>

        <!-- Pagination -->
        @if (!isLoading && paginatorOptions.last_page > 1) {
          <p-paginator
            [rows]="paginatorOptions.rows"
            [first]="paginatorOptions.first"
            [totalRecords]="paginatorOptions.total"
            (onPageChange)="onPageChange($event)"
          ></p-paginator>
        }
      </div>
    </div>
  </div>
</div>
